import {i18n} from '@netx/core/i18n';

export const RepurposePresetsLabel = {
	ROUTE: i18n.t('i18n.presets'),
};

export const REPURPOSE_ACTION_LABELS = {
	REPURPOSE: i18n.t('i18n.repurpose'),
};
